<template>
	<div class="form-container">
		<h3 class="vrnu-headline">{{ formData }}</h3>
		<b-form v-on:submit.prevent="save">
			<b-container class="no-padding">
				<b-row>
					<b-col>
						<b-form-group
							label="Ident"
							label-for="ident">
							<b-form-input id="ident"
								type="text"
								placeholder="Ident"
								v-model.trim="text.ident"
								v-validate="'required'"
								data-vv-name="Ident"
								:class="{'has-error': errors.has('Ident')}">
							</b-form-input>
							<p v-if="errors.has('Ident')" class="error-message">
								{{ errors.first('Ident') }}
						    </p>
						</b-form-group>
						<b-form-group
							label="Überschrift"
							label-for="headline">
							<b-form-input id="headline"
								type="text"
								placeholder="Titel"
								v-model.trim="text.headline"
								v-validate="'required'"
								data-vv-name="Titel"
								:class="{'has-error': errors.has('Titel')}">
							</b-form-input>
							<p v-if="errors.has('Titel')" class="error-message">
								{{ errors.first('Titel') }}
						    </p>
						</b-form-group>
            <b-form-group
              label="Text"
              label-for="text">
              <vue-editor id="text"
                          placeholder="Text"
                          v-model.trim="text.text"
                          v-validate="'required'"
                          data-vv-name="Text"
                          :class="{'has-error': errors.has('Text')}"
                          :editorToolbar="customToolbar"
                          :rows="3"
                          :max-rows="6">
              </vue-editor>
              <p v-if="errors.has('Text')" class="error-message">
                {{ errors.first('Text') }}
              </p>
            </b-form-group>
						<div class="space20"></div>
					</b-col>
				</b-row>
			</b-container>
			<b-button type="submit" class="vrnu-button" variant="primary">Speichern</b-button>
			<b-button type="reset" variant="secondary">Zurücksetzen</b-button>
		</b-form>		
	</div>
</template>

<script>
// Organize imports
import { checkIfTextIdentExists } from '../../validator/checkIfTextIdentExists.js';
import { VueEditor } from 'vue2-editor'

export default {
	data: function() {
		return {
			isUpdate: false,
			text: {
				ident: '',
				headline: '',
				text: '',
			},
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ],
		};
	},
	methods: {
		save: function() {
			this.$validator.validate().then(result => {
				if (!result) {
					// console.log("errors", this.$validator.errors);					
				} else {
					// Create a new data object
					var data = {							
							ident: this.text.ident,
							headline: this.text.headline,
							text: this.text.text,
					};
					
					// Send text to the server
					if(this.isUpdate) {
						// Update the text
		 				this.$http.put('texts/' + this.updateId, data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});				
					} else {								
						// Save the user
						this.$http.post('texts', data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});
					}
				}
			});
		},
		loadTextForUpdate: function() {
			// Get text from server
			this.$http.get('texts/' + this.updateId).then(text => {
				this.text = {
					ident: text.body.ident,
					headline: text.body.headline,
					text: text.body.text,
				};
			}, response => {
				// console.log(response);
				this.texts = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
		checkIfModeIsUpdate: function() {
			if(this.updateId !== null) {
				this.isUpdate = true;
				this.loadTextForUpdate();
			} else {
				this.isUpdate = false;
			}
		},
	},
	watch: {
		updateId: function() {
			this.checkIfModeIsUpdate();
		},
	},
	created: function() {
		this.checkIfModeIsUpdate();
		this.$validator.localize('de');
		
		// Extend the validator
    this.$validator.extend('checkIfTextIdentExists', checkIfTextIdentExists);
	},
	mounted: function() {
	},
	props: {
		formData: {
			required: true,
		},
		updateId: {
			default: null,
		}
	},
  components: {
	  VueEditor,
  },
}
</script>

<style>
.form-container {
	padding: 5px;
}
.mb-3 {
	margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/11_text/TextsForm.vue